<template>
  <div class="settings">
    <div class="settings__sidebar">
      <div class="settings__sidebar-container">
        <!-- <h3 class="settings__sidebar-container-title">Menu</h3> -->
        <div class="settings__sidebar-menu">
          <div class="settings__sidebar-btn"
            @click="menuSelected = 0"
            :class="[menuSelected === 0 ? 'settings__sidebar-btn-active' : '']">
            {{ $t('view.settings.admin.title') }}
          </div>
          <div class="settings__sidebar-btn"
            @click="menuSelected = 1"
            :class="[menuSelected === 1 ? 'settings__sidebar-btn-active' : '']">
            {{ $t('view.settings.chatbot.title') }}
          </div>
          <div class="settings__sidebar-btn"
            @click="menuSelected = 2"
            :class="[menuSelected === 2 ? 'settings__sidebar-btn-active' : '']">
            {{ $t('view.settings.platform.title') }}
          </div>
          <div class="settings__sidebar-btn"
            @click="menuSelected = 3"
            :class="[menuSelected === 3 ? 'settings__sidebar-btn-active' : '']">
            {{ $t('view.settings.personas.title') }}
          </div>
          <div class="settings__sidebar-btn"
            @click="menuSelected = 4"
            :class="[menuSelected === 4 ? 'settings__sidebar-btn-active' : '']">
            {{ $t('view.settings.statics.title') }}
          </div>
        </div>
      </div>
    </div>
    <div class="settings__wrapper editor">
      <div>
        <admin-settings v-if="menuSelected === 0"/>
        <chatbot-settings v-if="menuSelected === 1"/>
        <platforms-settings v-if="menuSelected === 2"/>
        <personas-settings v-if="menuSelected === 3"/>
        <static-settings v-if="menuSelected === 4"/>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
export default {
  data () {
    return {
      menuSelected: 0
    }
  },

  mounted () {
    this.$store.dispatch('loadFlowData', this)
  }
}
</script>

<style lang="scss">
.settings {
  display: flex;
  &__sidebar {
    @include viewSidebar();
  }

  &__sidebar-container-title {
    padding-left: 24px;
    margin-bottom: 5px;
  }

  &__sidebar-container {
    margin-bottom: 25px;
  }

  &__sidebar-menu {
    margin-top: 20px;
  }

  &__sidebar-btn {
    font-family: 'Work Sans';
    cursor: pointer;
    padding: 10px;
    width: 85%;
    margin: 3px auto 5px auto;
    font-size: 1.1em;
    text-transform: uppercase;
    transition: padding-left 0.3s;
    letter-spacing: 0.05em;
    color: $borderAccent;
    font-weight: 500;
  }

  &__sidebar-btn:hover:not(&__sidebar-btn-active) {
    padding-left: 25px;
  }

  &__sidebar-btn-active {
    padding-left: 40px;
  }
}
</style>